import { render, staticRenderFns } from "./VisitBlocked.vue?vue&type=template&id=5791de54&scoped=true"
import script from "./VisitBlocked.vue?vue&type=script&lang=js"
export * from "./VisitBlocked.vue?vue&type=script&lang=js"
import style0 from "./VisitBlocked.vue?vue&type=style&index=0&id=5791de54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5791de54",
  null
  
)

export default component.exports